// src/modules/Admin/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f5f5f5;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid #e0e0e0;
  border-top-color: #333;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const LoadingText = styled.p`
  margin-top: 16px;
  color: #666;
  font-size: 14px;
`;

const AccessDeniedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f5f5f5;
  padding: 24px;
  text-align: center;
`;

const AccessDeniedTitle = styled.h1`
  font-size: 24px;
  color: #333;
  margin-bottom: 12px;
`;

const AccessDeniedText = styled.p`
  color: #666;
  font-size: 14px;
  margin-bottom: 24px;
  max-width: 400px;
`;

const BackButton = styled.a`
  padding: 12px 24px;
  background: #333;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-weight: 500;
  transition: background 200ms;

  &:hover {
    background: #444;
  }
`;

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <LoadingContainer>
        <Spinner />
        <LoadingText>Verificando autenticação...</LoadingText>
      </LoadingContainer>
    );
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    return (
      <AccessDeniedContainer>
        <AccessDeniedTitle>Acesso Restrito</AccessDeniedTitle>
        <AccessDeniedText>
          Você não tem permissão para acessar esta área.
          Entre em contato com o administrador se acredita que isso é um erro.
        </AccessDeniedText>
        <BackButton href="/">Voltar ao site</BackButton>
      </AccessDeniedContainer>
    );
  }

  return children;
};

export default ProtectedRoute;
